/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/**
 * Custom JavaScript (no jQuery)
 */

document.addEventListener('DOMContentLoaded', function () {

  // Sticky header on scroll
  window.addEventListener('scroll', function () {
    const header = document.querySelector('.Header .Header__Wrapper');
    if (!header) return;

    if (window.scrollY >= 40) {
      header.classList.add('fixed');
    } else {
      header.classList.remove('fixed');
    }
  });

  // Close overlay on custom menu button click
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.custom_menu button.SelectButton.Link.Link--primary');
    if (!btn) return;

    const overlay = document.querySelector('.PageOverlay');
    if (overlay) overlay.classList.remove('is-visible');
  });

});
